"use strict";

module.exports = {
    "user2": {
        "add-account": "Дадаць акаўнт",
        "edit-accounts": "Рэдагаваць спіс",
        "enter": "Увайсці",
        "exit": "Выйсці",
        "help": "Дапамога",
        "mail": ["новы ліст", "новыя лісты", "новых лістоў", "Няма новых лістоў"],
        "mail_compose": "Напісаць ліст",
        "passport": "Кіраванне акаўнтам",
        "settings": "Наладкі",
        "upload_files": "Мой Дыск"
    }
};